const data = [
    {
        "box_condition": "no_original_box",
        "brand_name": "Nike",
        "category": [
            "lifestyle"
        ],
        "collection_slugs": [
            "air-max-day"
        ],
        "color": "Black",
        "designer": "Christian Tresser",
        "details": "Black/Reflect Silver-Blue Lagoon",
        "gender": [
            "men"
        ],
        "grid_picture_url": "https://image.goat.com/375/attachments/product_template_pictures/images/020/627/570/original/491891_00.png.png",
        "has_picture": true,
        "has_stock": true,
        "id": 491891,
        "keywords": [],
        "main_picture_url": "https://image.goat.com/750/attachments/product_template_pictures/images/020/627/570/original/491891_00.png.png",
        "midsole": "Air",
        "name": "Air Max 97 'On Air: Neon Seoul'",
        "nickname": "Neon Seoul",
        "original_picture_url": "https://image.goat.com/attachments/product_template_pictures/images/020/627/570/original/491891_00.png.png",
        "product_template_id": 491891,
        "release_date": "2019-04-13T07:00:00.000Z",
        "release_date_unix": 1555138800,
        "release_year": 2019,
        "retail_price_cents": 20000,
        "shoe_condition": "used",
        "silhouette": "Air Max 97",
        "size_range": [
            10,
            10.5,
            11,
            11.5,
            12,
            12.5,
            13,
            13.5,
            14,
            14.5,
            15,
            15.5,
            16,
            16.5,
            17,
            17.5,
            18,
            3.5,
            4,
            4.5,
            5,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5
        ],
        "sku": "CI1503 001",
        "slug": "air-max-97-neon-seoul-am-97-seoul",
        "status": "active",
        "story_html": "<p>In celebration of Air Max Day, Nike hosted the Nike: On Air contest in 2018, giving residents the chance to create their own Air Max designs inspired by their hometowns. After working alongside Nike developers, winner Gwang Shin debuted his Nike Air Max 97 &#39;Neon Seoul&#39; sneaker in April 2019. Paying tribute to his city, Seoul, Shin draws influences from the famed neon signs in South Korea’s capital, decorating the leather upper with vivid-colored piping.</p>\n",
        "upper_material": null
    },
    {
        "box_condition": "good_condition",
        "brand_name": "Air Jordan",
        "category": [
            "lifestyle"
        ],
        "collection_slugs": [
            "just-dropped",
            "just-dropped-1"
        ],
        "color": "Brown",
        "designer": "Tinker Hatfield",
        "details": "Shimmer/Mahogany Mink-Velvet Brown-Tough Red",
        "gender": [
            "men"
        ],
        "grid_picture_url": "https://image.goat.com/375/attachments/product_template_pictures/images/021/321/847/original/473391_00.png.png",
        "has_picture": true,
        "has_stock": true,
        "id": 473391,
        "keywords": [],
        "main_picture_url": "https://image.goat.com/750/attachments/product_template_pictures/images/021/321/847/original/473391_00.png.png",
        "midsole": "Air",
        "name": "Patta x Air Jordan 7 Retro OG SP 'Shimmer'",
        "nickname": "Shimmer",
        "original_picture_url": "https://image.goat.com/attachments/product_template_pictures/images/021/321/847/original/473391_00.png.png",
        "product_template_id": 473391,
        "release_date": "2019-05-18T07:00:00.000Z",
        "release_date_unix": 1558162800,
        "release_year": 2019,
        "retail_price_cents": 20000,
        "shoe_condition": "new_no_defects",
        "silhouette": "Air Jordan 7",
        "size_range": [
            10,
            10.5,
            11,
            11.5,
            12,
            12.5,
            13,
            13.5,
            14,
            14.5,
            15,
            15.5,
            16,
            16.5,
            17,
            17.5,
            18,
            3.5,
            4,
            4.5,
            5,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5
        ],
        "sku": "AT3375 200",
        "slug": "patta-x-air-jordan-7-retro-og-sp-shimmer-patta-aj7-shm",
        "status": "active",
        "story_html": "<p>Amsterdam-based boutique and streetwear brand, Patta joins forces with Jordan Brand to lend their signature aesthetic to the Patta x Air Jordan 7 Retro OG SP &#39;Shimmer&#39; sneaker. Part of a limited-edition capsule collection released in May 2019, this rendition sports an earth-toned color palette of Shimmer, Mahogany Mink, Velvet Brown and Tough Red hues on a premium leather and suede upper. Unique perforation patterns and an offset Jumpman logo accent the underlay, while signature Patta script dresses the triple-tone midsole. A durable rubber outsole equipped with Air technology reinforces the design, which is inspired by Michael Jordan&#39;s run with the Dream Team at the 1992 Summer Games in Barcelona.</p>\n",
        "upper_material": null
    },
    {
        "box_condition": "no_original_box",
        "brand_name": "adidas",
        "category": [
            "lifestyle"
        ],
        "collection_slugs": [
            "yeezy-1"
        ],
        "color": "Black",
        "designer": "Kanye West",
        "details": "Black/Black/Black",
        "gender": [
            "men"
        ],
        "grid_picture_url": "https://image.goat.com/375/attachments/product_template_pictures/images/020/624/696/original/FU9013.png.png",
        "has_picture": true,
        "has_stock": true,
        "id": 505488,
        "keywords": [
            "350 V2",
            "350",
            "Yeezy"
        ],
        "main_picture_url": "https://image.goat.com/750/attachments/product_template_pictures/images/020/624/696/original/FU9013.png.png",
        "midsole": "Boost",
        "name": "Yeezy Boost 350 V2 'Black Non-Reflective'",
        "nickname": "Black Non-Reflective",
        "original_picture_url": "https://image.goat.com/attachments/product_template_pictures/images/020/624/696/original/FU9013.png.png",
        "product_template_id": 505488,
        "release_date": "2019-06-08T23:59:59.000Z",
        "release_date_unix": 1560038399,
        "release_year": 2019,
        "retail_price_cents": 22000,
        "shoe_condition": "new_no_defects",
        "silhouette": "Yeezy Boost 350",
        "size_range": [
            10,
            10.5,
            11,
            11.5,
            12,
            12.5,
            13,
            13.5,
            14,
            14.5,
            15,
            16,
            17,
            18,
            19,
            20,
            3,
            3.5,
            4,
            4.5,
            5,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5
        ],
        "sku": "FU9006",
        "slug": "yeezy-boost-350-v2-black-yzy-350-v2-blk",
        "status": "active",
        "story_html": "<p>The adidas Yeezy Boost 350 V2 lives up to its cult appeal through evolved design elements and advanced technology. Released June 2019, this ‘Black Non-Reflective&#39; edition&#39;s re-engineered Primeknit bootie sees futuristic updates including a translucent side stripe and bold stitching on the heel pull. Integrated lacing customizes the fit while a translucent black Boost-equipped midsole complements the covert feel.</p>\n",
        "upper_material": "Primeknit"
    },
    {
        "box_condition": "good_condition",
        "brand_name": "Air Jordan",
        "category": [
            "lifestyle"
        ],
        "collection_slugs": [
            "under-retail-10"
        ],
        "color": "Black",
        "designer": "Peter Moore",
        "details": "Black/Varsity Red-Varsity Royal-White",
        "gender": [
            "men"
        ],
        "grid_picture_url": "https://image.goat.com/375/attachments/product_template_pictures/images/012/910/690/original/554724_065.png.png",
        "has_picture": true,
        "has_stock": true,
        "id": 397517,
        "keywords": [
            "promoted1",
            "underRetail"
        ],
        "main_picture_url": "https://image.goat.com/750/attachments/product_template_pictures/images/012/910/690/original/554724_065.png.png",
        "midsole": "Air",
        "name": "Air Jordan 1 Mid 'Multicolor Swoosh Black'",
        "nickname": "Multicolor Swoosh Black",
        "original_picture_url": "https://image.goat.com/attachments/product_template_pictures/images/012/910/690/original/554724_065.png.png",
        "product_template_id": 397517,
        "release_date": null,
        "release_date_unix": null,
        "release_year": null,
        "retail_price_cents": 11000,
        "shoe_condition": "new_with_defects",
        "silhouette": "Air Jordan 1",
        "size_range": [
            10,
            10.5,
            11,
            11.5,
            12,
            12.5,
            13,
            13.5,
            14,
            14.5,
            15,
            15.5,
            16,
            16.5,
            17,
            17.5,
            18,
            3.5,
            4,
            4.5,
            5,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5
        ],
        "sku": "554724 065",
        "slug": "air-jordan-1-mid-554724-065",
        "status": "active",
        "story_html": null,
        "upper_material": ""
    },

]

export default data;